<h2 mat-dialog-title>{{ 'LABEL.ADVANCED_SEARCH' | translate }}</h2>

<div mat-dialog-content>
  <form [formGroup]="form" fxLayout="row wrap" fxLayoutGap="8px grid">

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ 'LABEL.SEARCH' | translate }}</mat-label>
      <input matInput formControlName="text" />
      <button *ngIf="form.get('text')?.value" mat-icon-button matSuffix (click)="clearField('text')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <!-- ── RICHIESTA ── -->
    <div fxFlex="100"
      style="padding: 4px 0 2px; font-weight: 600; color: rgba(0,0,0,.6); font-size: 12px; text-transform: uppercase; letter-spacing: .05em;">
      {{ 'LABEL.REQUEST' | translate }}
    </div>

    <div fxFlex="100">
      <app-select-search formControlName="companyId" [items]="companies" viewField="name" [multiple]="true"
        [label]="'LABEL.COMPANY' | translate">
      </app-select-search>
    </div>

    <div fxFlex="100" *ngIf="form.get('companyId')?.value?.length"
      style="display:flex; flex-wrap:wrap; gap:4px; padding-top:0; padding-bottom:4px;">
      <span *ngFor="let item of form.get('companyId')?.value"
        style="display:inline-flex; align-items:center; background:#e0e0e0; border-radius:12px; padding:2px 4px 2px 10px; font-size:12px; line-height:20px; gap:2px;">
        {{ item.name }}
        <button type="button" (click)="removeSelection('companyId', item)"
          style="background:none; border:none; cursor:pointer; padding:0; display:flex; align-items:center; color:rgba(0,0,0,0.54);">
          <mat-icon style="font-size:16px; width:16px; height:16px; line-height:16px;">cancel</mat-icon>
        </button>
      </span>
    </div>

    <div fxFlex="100">
      <app-select-search formControlName="assignmentOperator" [items]="operators" viewField="email" [multiple]="true"
        [noUsers]="operators.length === 0" [label]="'LABEL.WORKER_ASS' | translate">
      </app-select-search>
    </div>

    <div fxFlex="100" *ngIf="form.get('assignmentOperator')?.value?.length"
      style="display:flex; flex-wrap:wrap; gap:4px; padding-top:0; padding-bottom:4px;">
      <span *ngFor="let item of form.get('assignmentOperator')?.value"
        style="display:inline-flex; align-items:center; background:#e0e0e0; border-radius:12px; padding:2px 4px 2px 10px; font-size:12px; line-height:20px; gap:2px;">
        {{ item.email }}
        <button type="button" (click)="removeSelection('assignmentOperator', item)"
          style="background:none; border:none; cursor:pointer; padding:0; display:flex; align-items:center; color:rgba(0,0,0,0.54);">
          <mat-icon style="font-size:16px; width:16px; height:16px; line-height:16px;">cancel</mat-icon>
        </button>
      </span>
    </div>

    <div fxFlex="100">
      <app-select-search formControlName="businessLineId" [items]="branches" viewField="branchCode" [multiple]="true"
        [label]="'LABEL.BRANCH' | translate">
      </app-select-search>
    </div>

    <div fxFlex="100" *ngIf="form.get('businessLineId')?.value?.length"
      style="display:flex; flex-wrap:wrap; gap:4px; padding-top:0; padding-bottom:4px;">
      <span *ngFor="let item of form.get('businessLineId')?.value"
        style="display:inline-flex; align-items:center; background:#e0e0e0; border-radius:12px; padding:2px 4px 2px 10px; font-size:12px; line-height:20px; gap:2px;">
        {{ item.branchCode }}
        <button type="button" (click)="removeSelection('businessLineId', item)"
          style="background:none; border:none; cursor:pointer; padding:0; display:flex; align-items:center; color:rgba(0,0,0,0.54);">
          <mat-icon style="font-size:16px; width:16px; height:16px; line-height:16px;">cancel</mat-icon>
        </button>
      </span>
    </div>

    <div fxFlex="100">
      <app-select-search formControlName="stateId" [items]="stateCategories" viewField="stateCode" [multiple]="true"
        [label]="'LABEL.STATUS' | translate">
      </app-select-search>
    </div>

    <div fxFlex="100" *ngIf="form.get('stateId')?.value?.length"
      style="display:flex; flex-wrap:wrap; gap:4px; padding-top:0; padding-bottom:4px;">
      <span *ngFor="let item of form.get('stateId')?.value"
        style="display:inline-flex; align-items:center; background:#e0e0e0; border-radius:12px; padding:2px 4px 2px 10px; font-size:12px; line-height:20px; gap:2px;">
        {{ item.stateCode }}
        <button type="button" (click)="removeSelection('stateId', item)"
          style="background:none; border:none; cursor:pointer; padding:0; display:flex; align-items:center; color:rgba(0,0,0,0.54);">
          <mat-icon style="font-size:16px; width:16px; height:16px; line-height:16px;">cancel</mat-icon>
        </button>
      </span>
    </div>

    <div fxFlex="100">
      <app-select-search formControlName="year" [items]="years" viewField="" [multiple]="true"
        [label]="'LABEL.YEAR' | translate">
      </app-select-search>
    </div>

    <div fxFlex="100" *ngIf="form.get('year')?.value?.length"
      style="display:flex; flex-wrap:wrap; gap:4px; padding-top:0; padding-bottom:4px;">
      <span *ngFor="let item of form.get('year')?.value"
        style="display:inline-flex; align-items:center; background:#e0e0e0; border-radius:12px; padding:2px 4px 2px 10px; font-size:12px; line-height:20px; gap:2px;">
        {{ item }}
        <button type="button" (click)="removeSelection('year', item)"
          style="background:none; border:none; cursor:pointer; padding:0; display:flex; align-items:center; color:rgba(0,0,0,0.54);">
          <mat-icon style="font-size:16px; width:16px; height:16px; line-height:16px;">cancel</mat-icon>
        </button>
      </span>
    </div>

    <!-- ── SOGGETTO ── -->
    <div fxFlex="100"
      style="padding: 4px 0 2px; font-weight: 600; color: rgba(0,0,0,.6); font-size: 12px; text-transform: uppercase; letter-spacing: .05em;">
      {{ 'LABEL.SUBJ' | translate }}
    </div>

    <mat-form-field appearance="outline" fxFlex="calc(50% - 8px)">
      <mat-label>{{ 'LABEL.NAME' | translate }}</mat-label>
      <input matInput formControlName="subjectName" />
      <button *ngIf="form.get('subjectName')?.value" mat-icon-button matSuffix (click)="clearField('subjectName')"
        type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="calc(50% - 8px)">
      <mat-label>{{ 'LABEL.LAST_NAME' | translate }}</mat-label>
      <input matInput formControlName="subjectSurname" />
      <button *ngIf="form.get('subjectSurname')?.value" mat-icon-button matSuffix (click)="clearField('subjectSurname')"
        type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ 'LABEL.LEGAL_ENTITY' | translate }}</mat-label>
      <input matInput formControlName="subjectLegalEntity" />
      <button *ngIf="form.get('subjectLegalEntity')?.value" mat-icon-button matSuffix
        (click)="clearField('subjectLegalEntity')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="100">
      <mat-label>{{ 'LABEL.EMAIL' | translate }}</mat-label>
      <input matInput formControlName="subjectEmail" type="email" />
      <button *ngIf="form.get('subjectEmail')?.value" mat-icon-button matSuffix (click)="clearField('subjectEmail')"
        type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="calc(50% - 8px)">
      <mat-label>{{ 'LABEL.FIX_TELEPHONE' | translate }}</mat-label>
      <input matInput formControlName="subjectTelephone1" />
      <button *ngIf="form.get('subjectTelephone1')?.value" mat-icon-button matSuffix
        (click)="clearField('subjectTelephone1')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="calc(50% - 8px)">
      <mat-label>{{ 'LABEL.MOBILE' | translate }}</mat-label>
      <input matInput formControlName="subjectTelephone2" />
      <button *ngIf="form.get('subjectTelephone2')?.value" mat-icon-button matSuffix
        (click)="clearField('subjectTelephone2')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <!-- ── EDIFICIO ── -->
    <div fxFlex="100"
      style="padding: 4px 0 2px; font-weight: 600; color: rgba(0,0,0,.6); font-size: 12px; text-transform: uppercase; letter-spacing: .05em;">
      {{ 'LABEL.BUILDING' | translate }}
    </div>

    <mat-form-field appearance="outline" fxFlex="calc(50% - 8px)">
      <mat-label>{{ 'ADDRESS.STREETNAME' | translate }}</mat-label>
      <input matInput formControlName="buildingStreetName" />
      <button *ngIf="form.get('buildingStreetName')?.value" mat-icon-button matSuffix
        (click)="clearField('buildingStreetName')" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="calc(50% - 8px)">
      <mat-label>{{ 'LABEL.CIVIC' | translate }}</mat-label>
      <input matInput formControlName="buildingStreetNumber" type="text" />
      <button *ngIf="form.get('buildingStreetNumber')?.value" mat-icon-button matSuffix (click)="clearField('buildingStreetNumber')"
        type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="calc(50% - 8px)">
      <mat-label>{{ 'LABEL.zip' | translate }}</mat-label>
      <input matInput formControlName="buildingZip" type="text" />
      <button *ngIf="form.get('buildingZip')?.value" mat-icon-button matSuffix (click)="clearField('buildingZip')"
        type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <mat-form-field appearance="outline" fxFlex="calc(50% - 8px)" >
      <mat-label>{{ 'ADDRESS.CITY' | translate }}</mat-label>
      <input matInput formControlName="buildingCity" />
      <button *ngIf="form.get('buildingCity')?.value" mat-icon-button matSuffix (click)="clearField('buildingCity')"
        type="button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

  </form>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ 'LABEL.CANCEL' | translate }}</button>
  <button mat-button color="warn" (click)="reset()" [matTooltip]="'LABEL.RESET_FILTERS_BTN' | translate">
    <mat-icon>filter_alt_off</mat-icon>
    {{ 'LABEL.RESET_FILTERS_BTN' | translate }}
  </button>
  <button mat-raised-button color="primary" (click)="search()">{{ 'LABEL.SEARCH' | translate }}</button>
</div>